/** Réglages des fonds du thème Rétro 8 bits (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    nombre: {
        type: "nombre", libelle: "Nombre d'éléments", min: 3, max: 20, pas: 1, defaut: 9,
        aide: "Objets, pièces ou nuages selon le fond (20 au plus, pour garder l'écran léger).",
    },
    palette: {
        type: "choix", libelle: "Palette", defaut: "jour",
        options: [{valeur: "jour", libelle: "Jour (ciel bleu)"}, {valeur: "soir", libelle: "Soir (orangé)"}, {valeur: "portable", libelle: "Console portable (4 verts)"}],
    },
};

/** Couleurs de chaque palette : ciel haut, ciel bas, collines loin, collines près, sol, motif du sol, objets, nuages. */
export const PALETTES = {
    jour: {haut: "#3a8de0", bas: "#9fd8ff", loin: "#5fb36a", pres: "#2f8a4a", sol: "#8a5a2b", motif: "#6b4220", objets: ["#e8e8f0", "#ffcf33", "#ff5d73", "#5cd1ff"], nuage: "#ffffff"},
    soir: {haut: "#3a1f6b", bas: "#ff9f5a", loin: "#7a3b8f", pres: "#4a2570", sol: "#40213a", motif: "#2c1528", objets: ["#fff1c9", "#ffcf33", "#ff7a9c", "#9be3ff"], nuage: "#ffc4a0"},
    portable: {haut: "#8bac0f", bas: "#9bbc0f", loin: "#6e8b0c", pres: "#306230", sol: "#0f380f", motif: "#306230", objets: ["#0f380f", "#306230", "#0f380f", "#306230"], nuage: "#c4d96b"},
};
